import {KilnInfo} from '@domain/kiln-monitoring'
import {HttpError} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {createRetryFunction} from '../helpers'
import {useAxios} from '../hooks'

export const GetKilnInfoQueryKey = 'kiln-info'

export const useGetKilnInfo = (
  plantUpmId: string | undefined,
  options?: UseQueryOptions<KilnInfo[], AxiosError<HttpError>>
) => {
  const axiosInstance = useAxios()

  return useQuery<KilnInfo[], AxiosError<HttpError>>({
    queryKey: [GetKilnInfoQueryKey, plantUpmId],
    queryFn: async () => {
      const path = `/kms/${plantUpmId}/kilns`
      return (await axiosInstance.get<KilnInfo[]>(path)).data
    },
    staleTime: 1000 * 60 * 60,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    throwOnError: (error) => {
      // 400 or 404 means there are no kilns configured for this plant
      const shouldThrowError = error.response?.status !== 400 && error.response?.status !== 404
      return shouldThrowError
    },
    retry: createRetryFunction(3),
    retryDelay: 1000 * 3,
    enabled: plantUpmId !== undefined,
    // allow the callee to override the default options
    ...options
  })
}
